import React, { Component } from 'react';
import ModalBox from '../../../shared/modal';

class GetConversionsForApprove extends Component {
	constructor(props) {
		super(props);
		this.state = { isPopupActive: false, data: '' };
		this.togglePopup = this.togglePopup.bind(this);
	}
	togglePopup() {
		this.setState(state => ({ isPopupActive: !state.isPopupActive }));
	}
	render() {
		return (
			<div>
				<Main
					{...this.props}
					togglePopup={this.togglePopup}
					isPopupActive={this.state.isPopupActive}
					data={this.state.data}
				/>
				<button
					onClick={() => this.props.getConversionsForApprove().then((data) => {
						if (data) {
							this.setState(state => ({ isPopupActive: true, data }));
						}
					})}
					type="button"
					className="ui-btn ui-btn-primary save"
				>
					{this.props.intl('Conversions for approve')}
				</button>
			</div>
		);
	}
}

const Main = props =>
	<ModalBox
		title={props.intl('Conversions for approve list:')}
		body={props.data ? PopupContent(props) : null}
		isOpen={props.isPopupActive}
		onClose={props.togglePopup}
		className=""
	/>;

const PopupContent = props =>
	<div className="adv-request__wrap">
		<ul>
			{props.data.map((val, index) =>
				<li key={index}>
					<p>Date: {val.d} Offer name: {val.offer_name}</p>
					<p>Will be approved: {val.toApproveCount}</p>
					<p></p>
				</li>
			)}
		</ul>
	</div>;
export default GetConversionsForApprove;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/conversions-approve/components/forms/get-conversions-for-approve.js